export default __webpack_public_path__ + "static/LeituraTwo-Black-328a1eef5a2b940b41c51246a012c57c.woff";